
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns/create",
      function () {
        return require("private-next-pages/campaigns/create/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns/create"])
      });
    }
  